export const monthLangEn = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December',
};

export const monthLangRu = {
  0: 'Январь',
  1: 'Февраль',
  2: 'Март',
  3: 'Апрель',
  4: 'Май',
  5: 'Июнь',
  6: 'Июль',
  7: 'Август',
  8: 'Сентябрь',
  9: 'Октябрь',
  10: 'Ноябрь',
  11: 'Декабрь',
};

export const monthLangBe = {
  0: 'Студзень',
  1: 'Люты',
  2: 'Сакавiк',
  3: 'Красавiк',
  4: 'Май',
  5: 'Червень',
  6: 'Лiпень',
  7: 'Жнiвень',
  8: 'Верасень',
  9: 'Кастрычнiк',
  10: 'Лiстапад',
  11: 'Снежань',
};